declare global {
  interface WindowGlobal {
    _satellite?: any
    digitalData?: any
  }
}

export const windowGlobal: global = typeof window !== "undefined" && window
